import { createContext, useReducer, useState, useContext } from 'react'

export const TargetContext = createContext() 

export const targetReducer = (state, action) => {
    switch (action.type) {
        case 'SET_TARGET':
            return { targets: action.payload }
        case 'CREATE_TARGET':
            return { targets: [action.payload, ...state.targets] }
        case 'UPDATE_TARGET':
            return { targets: action.payload }
        case 'DELETE_TARGET':
            return { targets: state.targets.filter(u => u._id !== action.payload._id) }
        case 'MERGE_TARGETS':
            return { targets: action.payload }
        case 'UNMERGE_TARGET':
            return { targets: action.payload }
        default:
            return state
    }
}

export const TargetContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(targetReducer, { targets: [] })
    const [targetTarget, setTargetTarget] = useState(null)
    return (<TargetContext.Provider value={{ ...state, dispatch, targetTarget, setTargetTarget}}>{ children }</TargetContext.Provider>)
}

export const useTargetContext = () => {
    const context = useContext(TargetContext)
    if(!context) throw Error('useTargetContext must be used inside an TargetContextProvider')
    return context
}